// At `/`, route based on session. Signed-in users land on the Dashboard,
// signed-out users get sent to Login. The marketing landing on
// app.klemento.com is gone; sign-in is the home.

import { useSession } from "../lib/auth";
import { RedirectTo } from "../components/RedirectTo";

export function HomeOrDashboard() {
  const { data: session, isPending } = useSession();
  if (isPending) {
    // Render nothing while session resolves to avoid a flicker into Login
    // for already-signed-in users.
    return null;
  }
  if (session?.user?.id) {
    return <RedirectTo to="/dashboard" />;
  }
  return <RedirectTo to="/login" />;
}
